import { SET_USER,SET_EVENTS,SET_TOKEN,LOG_OUT } from './type';
const initialData={user:null,events:[],token:null}

export default function userReducer(state = initialData, action) {
  switch (action.type) {
      case SET_USER:
      return {
        ...state,
        user:action.data
      }
      case SET_EVENTS:
      return {
        ...state,
        events:action.data
      }
      case SET_TOKEN:
      return {
        ...state,
        token:action.data
      }
      case LOG_OUT:
      return {
        ...state,
        token:null,
        events:[],
        user:null
      }
    default:
      return state;
  }
}